module.exports = __webpack_public_path__ + "static/media/DecRatesArrow.354f8cb7.tsx";